// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2h8IL","inputDescription":"styles_inputDescription__EeAWv"};